import ReactDOM from "react-dom/client";
import Main from "./Main";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Main />);
